<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2 v-show="!trash">Operating Areas</h2>
				<h2 v-show="trash">Operating Areas - Trash</h2>
			</b-col>
		</div>
		<div class="card">
			<div class="card-body">
				<b-row>
					<b-container fluid>
						<div class="row">
							<b-col lg="4" md="6" xs="12" class="my-1">
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<b-form-input v-model="filter" placeholder="Search" />
										<b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
									</div>
								</div>
							</b-col>
							<b-col v-show="view1" lg="3" class="my-1">
								<b-dropdown class="pull-left" :text="dpdt">
									<b-dropdown-item @click="trashOA()">Active</b-dropdown-item>
									<b-dropdown-item @click="trashOA()">Trash</b-dropdown-item>
								</b-dropdown>
							</b-col>
							<b-col lg="5" md="6" xs="12">
								<b-button v-show="view1" @click="operatingAreaModal" variant="primary" class="active mb-3 pull-right">Add Operating Area</b-button>
							</b-col>
						</div>
						<b-row v-if="loadingData">
							<b-col cols="12" sm="12" md="12" lg="12">
								<p class="text-center">
									<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
								</p>
							</b-col>
						</b-row>
						<b-table class="animated fadeIn" v-else striped hover bordered show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered"
							@row-clicked="rowClicked">
						</b-table>
						<!-- User Interface controls -->
						<b-row>
							<b-col lg="2" md="2" sm="12" class="my-1 pull-left">
								<div class="input-group mb-3">
									<div class="input-group-prepend"> </div>
									<b-select :options="pageOptions" v-model="perPage" />
								</div>
							</b-col>
							<b-col lg="10" md="10" sm="12" class="my-1 pull-right">
								<b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
							</b-col>
						</b-row>
					</b-container>
				</b-row>
		    </div>
		</div>
		    <!-- New EModal -->
	<b-modal title="New Operating Area" size="lg"  v-model="newOperatingArea" hide-header-close no-close-on-backdrop no-close-on-esc>
	<b-row>
		<b-col cols="12">
			<!-- Added by Carlos Rondon 14/02/2019 trucking company
			<b-form-group v-if="role =='super_admin'" :label-cols="4" id="L4" label="Company Type" label-for="CompanyTypeID" horizontal>
				<b-form-select id="CompanyTypeID" v-model="model.company_type" :options="companyselect" />
			</b-form-group>
			 End Added -->
			<b-form-group :label-cols="4" id="L1" label="Operating Area Name" label-for="OperatingANameID" horizontal>
				<b-form-input id="OperatingANameID" type="text" v-model="model.name"></b-form-input>
			</b-form-group>
			<b-form-group v-if="role =='super_admin' && energycompanyselect.length > 0 " :label-cols="4" id="L4" label="Energy Company" label-for="EnergyCompanyID" horizontal>
				<b-form-select value-field="id" text-field="company_name" id="EnergyCompanyID" v-model="model.energy_company_id" :options="energycompanyselect" @input="select_energy_company"/>
			</b-form-group>
			<b-form-group :label-cols="4" id="L11" label="Company Cosigner" label-for="company_cosigner" horizontal>
              <b-form-input id="company_cosigner" type="text" v-model="model.company_cosigner"  autocomplete="off"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L13" label="Phone Number" label-for="phone_number" horizontal>
              <b-form-input id="phone_number" placeholder="##########" v-mask="'##########'" type="tel" autocomplete="off" v-model="model.phone_number"></b-form-input>
            </b-form-group>
			<!-- Added by Carlos Rondon 14/02/2019 trucking company 
			<b-form-group v-if="model.company_type=='Trucking Company' & truckingcompanyselect.length > 0" :label-cols="4" id="TC4" label="Trucking  Companies" label-for="TcID" horizontal>	
				<b-form-checkbox-group value-field="id" text-field="name" class="custom-checkboxes" :options="truckingcompanyselect" name="Checkboxes2" plain v-model="model.trucking_company_id" @input="truckingcompanyTypeChange"></b-form-checkbox-group>
				<b-form-checkbox style="margin-top: 15px;" v-model="truckingcompanyAllSelected" :indeterminate="indeterminate" aria-describedby="" aria-controls="" plain @change="truckingcompanyToggleAll">
							{{ truckingcompanyAllSelected ? 'Un-select All' : 'Select All' }}
				</b-form-checkbox>
			</b-form-group>-->
			<!-- End Added -->
			<!-- Modified by Carlos Rondon 15/02/2019 trucking company -->
			<b-form-group v-if="loadlocationselect.length > 0" :label-cols="4" id="L5" label="Load Locations" label-for="loadLocationsID" horizontal>
			<!-- End  Modified-->	
				<b-form-checkbox-group value-field="id" text-field="legal_location"  class="custom-checkboxes" :options="loadlocationselect" name="Checkboxes2" plain v-model="model.load_locations_id" @input="loadLocationsChange"></b-form-checkbox-group>
				<b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="LLToggleAll">
					{{ llAllSelected ? 'Un-select All' : 'Select All' }}
				</b-form-checkbox>
			</b-form-group>
			<b-form-group v-if="unloadlocationselect.length > 0" :label-cols="4" id="L5" label="Unload Locations" label-for="unloadLocationsID" horizontal>
				<b-form-checkbox-group value-field="id" text-field="legal_location" class="custom-checkboxes" :options="unloadlocationselect" name="Checkboxes2" plain v-model="model.unload_locations_id" @input="unloadLocationsChange"></b-form-checkbox-group>
				<b-form-checkbox style="margin-top: 15px;" v-model="ulAllSelected" :indeterminate="indeterminateUL" aria-describedby="" aria-controls="" plain @change="ULToggleAll">
					{{ ulAllSelected ? 'Un-select All' : 'Select All' }}
				</b-form-checkbox>
			</b-form-group>
		</b-col>
	</b-row>

		<div slot="modal-footer" class="w-100">
			<b-btn size="md" variant="secondary" @click="newOperatingArea=false" class="float-left">Cancel</b-btn>
			<b-btn :disabled="savebtn" size="md" variant="primary" @click="saveOperatingAreas(model)" class="float-right">Save</b-btn>
		</div>
	</b-modal>
	<!-- End New  Modal-->
		<!-- Table Config -->
		<b-modal title="Config Table" v-model="configTable" ok-variant = "primary">
			<b-row>
				<b-col cols="12">
					<b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">
						<b-form-checkbox value="id" :disabled="true" @change="actionField('name')">Operating Area Name</b-form-checkbox>
						<b-form-checkbox value="name" :disabled="true" @change="actionField('trucking_company_name')">Truck Company Name</b-form-checkbox>
  					</b-form-checkbox-group>
				</b-col>
			</b-row>
		</b-modal> 
	<!-- Table Config-->
	</div>
</template>

<script>
	//import locations_service from './locations_service'
	// Agregado por Carlos Rondon
	import Vue from 'vue'
	//import vSelect from 'vue-select'
	import operating_areas_service from './operating_areas_service'

	//Vue.component('v-select', vSelect)
	// Hasta Aqui

	const items = []
	const fields = ['details', 'id', 'name', 'actions']
	export default {
		name: 'm_operating_areas',
		created: function() {
			this.getAll()
			localStorage.removeItem("haulsaPage");
			localStorage.removeItem("targetsaPage");
			localStorage.removeItem("ftPage");
			localStorage.removeItem("targetPage");
			localStorage.removeItem("tpPage");
			localStorage.removeItem("oasaPage");
			localStorage.removeItem("oasaPage");
			localStorage.removeItem("reportPage");
			localStorage.removeItem("truckPage");
      localStorage.removeItem("locationPage");
      localStorage.removeItem("tasaPage");
      localStorage.removeItem("rolesPage");
      localStorage.removeItem("servicePage");
      localStorage.removeItem("taPage");
      localStorage.removeItem("tcPage");
      localStorage.removeItem("userPage");
      if (!localStorage.oaPage) {
          localStorage.oaPage = 0;
      }
		},
		data() {
			return {
				trash: false,
				isSuperAnalyst: false,
				dpdt: 'Active',
				indeterminateLL: false,
				llAllSelected: false,
				indeterminateUL: false,
				indeterminate: false,
				ulAllSelected: false,
				insert_data: null,

				newOperatingArea: false,
				items: items,
				loadingData: true,
				currentPage: parseInt(localStorage.oaPage),
				perPage: 25,
				totalRows: items.length,
				pageOptions: [25, 50, 100],
				sortBy: null,
				sortDesc: false,
				fields: [{
						key: 'id',
						label: 'ID'
					},{
						key: 'name',
						label: 'Operating Area Name'
					},
					{
						key: 'energy_company_name',
						label: 'Energy Company Name'
					},
					{
						key: 'company_cosigner',
						label: 'Company Cosigner',
						sortable: true
					},
					{
						key: 'phone_number',
						label: 'Phone Number',
						sortable: true
					}
				],
				filter: null,
				configTable: false,
				selectedItems: ['id', 'name', 'status'],
				selected: null,
				options: [],
				operatingareaselect: [],
				energycompanyselect: [],
				loadlocationselect: [],
				unloadlocationselect: [],

				model: {
					name				: '',
					energy_company_id	: '',
					load_locations_id	: [],
					unload_locations_id	: [],
					company_cosigner    : '',
          			phone_number        : '',
				},
				role					:'',
				view					:true,
				view1					:true,
				savebtn					:true,
				energy_company_id 		:null,
			}
		},
		computed: {
			sortOptions() {
				// Create an options list from our fields
				return this.fieldsTh
					.filter(f => f.sortable)
					.map(f => {
						return {
							text: f.label,
							value: f.key
						}
					})
			}
		},
		methods: {
			rowClicked(row) {
				localStorage.oaPage = this.currentPage;
				if(!this.trash) {
					localStorage.setItem('xyz', row.id)
					this.$router.push('/operating_area/' + row.id + '/')
				} else {
					this.restoreOA(row.id)
				}
			},
			trashOA() {
				this.trash = !this.trash
				this.dpdt = this.trash ? "Trash" : "Active"
				this.getAll()
				this.loadingData = true
			},
			operatingAreaModal() {

				this.model.energy_company_id 		= ''
				this.model.name 					= ''	
				this.model.company_cosigner			= ''
				this.model.phone_number				= ''
				this.model.load_locations_id 		= []
				this.model.unload_locations_id 		= []
				this.savebtn						= false
				this.newOperatingArea 				= true
				if (this.role =='super_admin') {
					this.loadlocationselect					= [],
					this.unloadlocationselect				= []
				}

			},

			select_energy_company() {
				if (this.role =='super_admin') {
					let energy_companies = this.insert_data.energy_companies
					// this.unloadlocationselect 			= this.insert_data.unload_locations
					
					let energy_company_index = energy_companies.map(o => o.id).indexOf(this.model.energy_company_id)
					if (energy_company_index > -1) {
						let loadlocations = energy_companies[energy_company_index].load_locations
						let unloadlocations = energy_companies[energy_company_index].unload_locations
						this.loadlocationselect = [...loadlocations]
						this.unloadlocationselect 			= [...unloadlocations]
					} else {
						this.loadlocationselect = []
						this.unloadlocationselect = []
					}
					this.model.load_locations_id = []
					this.model.unload_locations_id	= []
				}
			},
			LLToggleAll(checked) {
				this.model.load_locations_id = checked ? this.loadlocationselect.map(item => {
					return item.id
				}) : []
			},
			ULToggleAll(checked) {
				this.model.unload_locations_id = checked ? this.unloadlocationselect.map(item => {
					return item.id
				}) : []
			},
			loadLocationsChange() {
				if (this.role =='super_admin') {
					if (this.model.load_locations_id.length === 0) {
						this.indeterminateLL = false
						this.llAllSelected = false
					} else if (this.model.load_locations_id.length === this.loadlocationselect.length) {
						this.indeterminateLL = false
						this.llAllSelected = true
					} else {
						this.indeterminateLL = true
						this.llAllSelected = false
					}
				}
			},
			unloadLocationsChange() {
				if (this.role =='super_admin') {
					if (this.model.unload_locations_id.length === 0) {
						this.indeterminateUL = false
						this.ulAllSelected = false
					} else if (this.model.unload_locations_id.length === this.unloadlocationselect.length) {
						this.indeterminateUL = false
						this.ulAllSelected = true
					} else {
						this.indeterminateUL = true
						this.ulAllSelected = false
				}
				}
			},
			actionField(option) {
				var fieldsThLength = this.fieldsTh.length
				var fieldIsActive = false
				for (var i = 0; i <= fieldsThLength; i++) {
					fieldIsActive = true
					try {
						if (this.fieldsTh[i].key === option || this.fieldsTh[i] === option) {
							this.fieldsTh.splice(i, 1)
							fieldIsActive = false
							break
						}
					} catch (err) {
						var position = this.fields.indexOf(option)
						this.fieldsTh.splice(position, 0, option)
					}
				}
			},
			onFiltered(filteredItems) {
				// Trigger pagination to update the number of buttons/pages due to filtering
				this.currentPage = parseInt(localStorage.oaPage)
				this.totalRows = filteredItems.length
				this.currentPage = 1
			},
			okToSave() {
				if (this.role =='super_admin' || this.role =='super_analyst' || this.role =='analyst' || this.role =='operations_manager' || this.role =='marketing_accountant'
				) {
					console.log('ok')
				}

				if (this.model.name === undefined || this.model.name.trim().length == 0) {
					this.$swal('Alert!', 'Operating Area Name can not be empty', 'warning')
					return false
				}

				return true
			},
			saveOperatingAreas(model) {
				this.savebtn=true
				if (this.role =='super_analyst' || this.role =='analyst' || this.role =='operations_manager' || this.role =='marketing_accountant') {
					this.model.energy_company_id 		= this.energy_company_id
				}
				if (!this.okToSave()) {
					this.savebtn=false
					return
				}
				model = {
					name				: model.name,
					energy_company_id	: this.model.energy_company_id,
					company_cosigner	: this.model.company_cosigner,
					phone_number		: this.model.phone_number,
					load_locations: model.load_locations_id.map(item => {
						return {
							id: String(item)
						}
					}),
					unload_locations: model.unload_locations_id.map(item => {
						return {
							id: String(item)
						}
					}),
				}
				this.savebtn=true
				operating_areas_service.save(model)
					.then(data => {
						this.$swal(data[0], data[1], data[0])
						if (data[0] == 'success') {
							this.newOperatingArea = false
							this.getAll()
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.savebtn=true
			},
			restoreOA(id) {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to restore this Operating Area?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						operating_areas_service.restore(id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.filter = ''
									this.trash = false
									this.getAll()
									this.loadingData = true
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			getAll() {
				this.loadingData = true
				operating_areas_service.getAll()
					.then(data => {
						if (data[0] == 'success') {
							this.items = data[1].filter(o => o.status_id == (this.trash ? 2 : 1))
							this.insert_data = data[2]
							// this.unloadlocationselect = this.insert_data.unload_locations
							this.energycompanyselect 	= this.insert_data.energy_companies
							// Added by Carlos Rondon 14/02/2019 trucking company
							this.truckingcompanyselect = this.insert_data.trucking_companies
							// End Added
							this.role = data[3]
							if (this.role =='super_admin') {
								this.view=true
								this.view1=true
							} else if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
								this.view=false
								this.view1=true
								this.energy_company_id = data[4]
								//let loadlocations = this.energycompanyselect[0].load_locations
								//this.loadlocationselect = [...loadlocations]
								//let unloadlocations = this.energycompanyselect[0].unload_locations
								//this.unloadlocationselect = [...unloadlocations]
								//this.model.load_locations_id = []
								//this.model.unload_locations_id = []
								//this.companyselect= ['Energy Company']
								//this.model.company_type = 'Energy Company'
							} else if (this.role =='operations_manager') {
								this.view=false
								this.view1=true
								this.energy_company_id = data[4]
								//let loadlocations = this.energycompanyselect[0].load_locations
								//this.loadlocationselect = [...loadlocations]
								//let unloadlocations = this.energycompanyselect[0].unload_locations
								//this.unloadlocationselect = [...unloadlocations]
								//this.model.load_locations_id = []
								//this.model.unload_locations_id = []
								//this.companyselect= ['Energy Company']
								//this.model.company_type = 'Energy Company'
							} else if (this.role =='trucking_company_admin' || this.role =='trucking_operational_manager' ) {
								this.view1=false
							}
							this.get_attributtes() 
						} else {
							this.items = []
							this.$swal(data[0], data[1], data[0])
						}
						this.loadingData = false
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			get_attributtes() {
				operating_areas_service.get_attr()
					.then(data => {
						if (data[0] === 'success') {
							this.insert_data  			= data[1]
							this.energycompanyselect 	= this.insert_data.energy_companies
							if (this.role =='super_analyst' || this.role =='analyst' || this.role =='operations_manager' || this.role =='marketing_accountant') {
								let loadlocations = this.energycompanyselect[0].load_locations
								this.loadlocationselect = [...loadlocations]
								let unloadlocations = this.energycompanyselect[0].unload_locations
								this.unloadlocationselect = [...unloadlocations]
								this.model.load_locations_id = []
								this.model.unload_locations_id = []
							} 
						} else {
							this.$swal(data[0], data[1], data[0])
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/operating_areas/m_operating_areas.vue